import { ReactComponent as AddIcon } from "../../assets/icons/add.svg";
import { ReactComponent as AddressIcon } from "../../assets/icons/address.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/icons/archive.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow-down.svg";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowUpIcon } from "../../assets/icons/arrow-up.svg";
import { ReactComponent as AssignSalesRepsIcon } from "../../assets/icons/assign-sales-reps.svg";
import { ReactComponent as AttachmentIcon } from "../../assets/icons/attachment.svg";
import { ReactComponent as BellOffIcon } from "../../assets/icons/bell-off.svg";
import { ReactComponent as BellOnIcon } from "../../assets/icons/bell-on.svg";
import { ReactComponent as BookIcon } from "../../assets/icons/book.svg";
import { ReactComponent as BudgetsIcon } from "../../assets/icons/budgets.svg";
import { ReactComponent as BuyersIcon } from "../../assets/icons/buyers.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar.svg";
import { ReactComponent as CartIcon } from "../../assets/icons/cart.svg";
import { ReactComponent as ChartIcon } from "../../assets/icons/chart.svg";
import { ReactComponent as ChatIcon } from "../../assets/icons/chat.svg";
import { ReactComponent as CheckCircleOffIcon } from "../../assets/icons/check-circle-off.svg";
import { ReactComponent as CheckCircleOnIcon } from "../../assets/icons/check-circle-on.svg";
import { ReactComponent as CheckboxIndeterminateIcon } from "../../assets/icons/checkbox-indeterminate.svg";
import { ReactComponent as CheckboxIndeterminateSolidIcon } from "../../assets/icons/checkbox-indeterminate-solid.svg";
import { ReactComponent as CheckboxOffIcon } from "../../assets/icons/checkbox-off.svg";
import { ReactComponent as CheckboxOnIcon } from "../../assets/icons/checkbox-on.svg";
import { ReactComponent as CheckmarkIcon } from "../../assets/icons/checkmark.svg";
import { ReactComponent as ChevronDownIcon } from "../../assets/icons/chevron-down.svg";
import { ReactComponent as ChevronLeftIcon } from "../../assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "../../assets/icons/chevron-right.svg";
import { ReactComponent as ChevronUpIcon } from "../../assets/icons/chevron-up.svg";
import { ReactComponent as CircleIcon } from "../../assets/icons/circle.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/clock.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as CloudDownloadOutlineIcon } from "../../assets/icons/cloud-download-outline.svg";
import { ReactComponent as CollectionIcon } from "../../assets/icons/collection.svg";
import { ReactComponent as CompanyIcon } from "../../assets/icons/company.svg";
import { ReactComponent as ConnectionOffIcon } from "../../assets/icons/connection-off.svg";
import { ReactComponent as ContractIcon } from "../../assets/icons/contract.svg";
import { ReactComponent as ContractVerticalIcon } from "../../assets/icons/contract-vertical.svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/copy.svg";
import { ReactComponent as CreditCardIcon } from "../../assets/icons/credit-card.svg";
import { ReactComponent as CropIcon } from "../../assets/icons/crop.svg";
import { ReactComponent as DetailsIcon } from "../../assets/icons/details.svg";
import { ReactComponent as DiscountsIcon } from "../../assets/icons/discounts.svg";
import { ReactComponent as DoorsIcon } from "../../assets/icons/doors.svg";
import { ReactComponent as DownloadIcon } from "../../assets/icons/download.svg";
import { ReactComponent as DragIcon } from "../../assets/icons/drag.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { ReactComponent as EllipsesIcon } from "../../assets/icons/ellipses.svg";
import { ReactComponent as ExclamationIcon } from "../../assets/icons/exclamation.svg";
import { ReactComponent as ExitIcon } from "../../assets/icons/exit.svg";
import { ReactComponent as ExpandIcon } from "../../assets/icons/expand.svg";
import { ReactComponent as ExpandVerticalIcon } from "../../assets/icons/expand-vertical.svg";
import { ReactComponent as ExportCsvIcon } from "../../assets/icons/export-csv.svg";
import { ReactComponent as FileIcon } from "../../assets/icons/file.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as FlagIcon } from "../../assets/icons/flag.svg";
import { ReactComponent as FlashIcon } from "../../assets/icons/flash.svg";
import { ReactComponent as FlashSolidIcon } from "../../assets/icons/flash-solid.svg";
import { ReactComponent as GiftIcon } from "../../assets/icons/gift.svg";
import { ReactComponent as GlobalIcon } from "../../assets/icons/global.svg";
import { ReactComponent as GridIcon } from "../../assets/icons/grid.svg";
import { ReactComponent as GroupIcon } from "../../assets/icons/group.svg";
import { ReactComponent as HeartOffIcon } from "../../assets/icons/heart-off.svg";
import { ReactComponent as HeartOnIcon } from "../../assets/icons/heart-on.svg";
import { ReactComponent as HomeIcon } from "../../assets/icons/home.svg";
import { ReactComponent as HubsIcon } from "../../assets/icons/hubs.svg";
import { ReactComponent as ImageIcon } from "../../assets/icons/image.svg";
import { ReactComponent as InformationIcon } from "../../assets/icons/information.svg";
import { ReactComponent as KabobIcon } from "../../assets/icons/kabob.svg";
import { ReactComponent as LayerIcon } from "../../assets/icons/layer.svg";
import { ReactComponent as LightbulbIcon } from "../../assets/icons/lightbulb.svg";
import { ReactComponent as LinkIcon } from "../../assets/icons/link.svg";
import { ReactComponent as LinkOutIcon } from "../../assets/icons/link-out.svg";
import { ReactComponent as ListIcon } from "../../assets/icons/list.svg";
import { ReactComponent as LockIcon } from "../../assets/icons/lock.svg";
import { ReactComponent as MenuIcon } from "../../assets/icons/menu.svg";
import { ReactComponent as MergeIcon } from "../../assets/icons/merge.svg";
import { ReactComponent as MessageIcon } from "../../assets/icons/message.svg";
import { ReactComponent as MicOffIcon } from "../../assets/icons/mic-off.svg";
import { ReactComponent as MicOnIcon } from "../../assets/icons/mic-on.svg";
import { ReactComponent as MinusCircleOutlineIcon } from "../../assets/icons/minus-circle-outline.svg";
import { ReactComponent as MoveIcon } from "../../assets/icons/move.svg";
import { ReactComponent as NoIcon } from "../../assets/icons/no.svg";
import { ReactComponent as OrderIcon } from "../../assets/icons/order.svg";
import { ReactComponent as OrderReviewIcon } from "../../assets/icons/order-review.svg";
import { ReactComponent as PagesIcon } from "../../assets/icons/pages.svg";
import { ReactComponent as PasteIcon } from "../../assets/icons/paste.svg";
import { ReactComponent as PauseIcon } from "../../assets/icons/pause.svg";
import { ReactComponent as PaymentMethodsIcon } from "../../assets/icons/payment-methods.svg";
import { ReactComponent as PersonAddIcon } from "../../assets/icons/person-add.svg";
import { ReactComponent as PersonIcon } from "../../assets/icons/person.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";
import { ReactComponent as PlaneIcon } from "../../assets/icons/plane.svg";
import { ReactComponent as PlayIcon } from "../../assets/icons/play.svg";
import { ReactComponent as PriceTypesIcon } from "../../assets/icons/price-types.svg";
import { ReactComponent as QrIcon } from "../../assets/icons/qr.svg";
import { ReactComponent as QuestionIcon } from "../../assets/icons/question.svg";
import { ReactComponent as RadioOffIcon } from "../../assets/icons/radio-off.svg";
import { ReactComponent as RadioOnIcon } from "../../assets/icons/radio-on.svg";
import { ReactComponent as ReplyIcon } from "../../assets/icons/reply.svg";
import { ReactComponent as ResetIcon } from "../../assets/icons/reset.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as SendBackwardsIcon } from "../../assets/icons/send-backwards.svg";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ReactComponent as ShareIcon } from "../../assets/icons/share.svg";
import { ReactComponent as ShippingAndBillingIcon } from "../../assets/icons/shipping-and-billing.svg";
import { ReactComponent as ShippingMethodsIcon } from "../../assets/icons/shipping-methods.svg";
import { ReactComponent as ShoppingBagIcon } from "../../assets/icons/shopping-bag.svg";
import { ReactComponent as SortIcon } from "../../assets/icons/sort.svg";
import { ReactComponent as SoundOffIcon } from "../../assets/icons/sound-off.svg";
import { ReactComponent as SoundOnIcon } from "../../assets/icons/sound-on.svg";
import { ReactComponent as StarOffIcon } from "../../assets/icons/star-off.svg";
import { ReactComponent as StarOnIcon } from "../../assets/icons/star-on.svg";
import { ReactComponent as SubtractIcon } from "../../assets/icons/subtract.svg";
import { ReactComponent as SyncIcon } from "../../assets/icons/sync.svg";
import { ReactComponent as TagIcon } from "../../assets/icons/tag.svg";
import { ReactComponent as TextIcon } from "../../assets/icons/text.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/trash.svg";
import { ReactComponent as UploadIcon } from "../../assets/icons/upload.svg";
import { ReactComponent as VideoOffIcon } from "../../assets/icons/video-off.svg";
import { ReactComponent as VideoOnIcon } from "../../assets/icons/video-on.svg";
import { ReactComponent as VisibilityOffIcon } from "../../assets/icons/visibility-off.svg";
import { ReactComponent as VisibilityOnIcon } from "../../assets/icons/visibility-on.svg";
import { ReactComponent as VisibleToAllIcon } from "../../assets/icons/all-visible.svg";
import { ReactComponent as WarehousesIcon } from "../../assets/icons/warehouses.svg";
import { ReactComponent as WarningIcon } from "../../assets/icons/warning.svg";
import { ReactComponent as XCloseIcon } from "../../assets/icons/x-close.svg";
import { ReactComponent as _360Icon } from "../../assets/icons/360.svg";
import { ReactComponent as _3dIcon } from "../../assets/icons/3d.svg";

// Templates

import { ReactComponent as _2Styles } from "../../assets/icons/templates/2 Styles.svg";
import { ReactComponent as _4Styles } from "../../assets/icons/templates/4 Styles.svg";
import { ReactComponent as _4StylesA } from "../../assets/icons/templates/4 Styles - A.svg";
import { ReactComponent as _4StylesB } from "../../assets/icons/templates/4 Styles - B.svg";
import { ReactComponent as _8Styles } from "../../assets/icons/templates/8 Styles.svg";
import { ReactComponent as _12Styles } from "../../assets/icons/templates/12 Styles.svg";
import { ReactComponent as WithInventoryATS } from "../../assets/icons/templates/With Inventory ATS.svg";
import { ReactComponent as ByFabrication } from "../../assets/icons/templates/By Fabrication.svg";

const semanticIconMap = {
  checked: CheckboxOnIcon,
  error: ExclamationIcon,
  "flag-error": FlagIcon,
  "flag-success": FlagIcon,
  "flag-warning": FlagIcon,
  "heart-off": HeartOffIcon,
  "heart-on": HeartOffIcon,
  information: InformationIcon,
  no: NoIcon,
  "star-off": StarOffIcon,
  "star-on": StarOnIcon,
  success: CheckCircleOnIcon,
  warning: WarningIcon,
} as const;

const nonSemanticIconMap = {
  "360": _360Icon,
  "3d": _3dIcon,
  add: AddIcon,
  address: AddressIcon,
  archive: ArchiveIcon,
  "arrow-down": ArrowDownIcon,
  "arrow-left": ArrowLeftIcon,
  "arrow-right": ArrowRightIcon,
  "arrow-up": ArrowUpIcon,
  "assign-sales-reps": AssignSalesRepsIcon,
  attachment: AttachmentIcon,
  "bell-off": BellOffIcon,
  "bell-on": BellOnIcon,
  book: BookIcon,
  budgets: BudgetsIcon,
  buyers: BuyersIcon,
  calendar: CalendarIcon,
  cart: CartIcon,
  chart: ChartIcon,
  chat: ChatIcon,
  "checkbox-on": CheckboxOnIcon,
  "checkbox-off": CheckboxOffIcon,
  "checkbox-indeterminate": CheckboxIndeterminateIcon,
  "checkbox-indeterminate-solid": CheckboxIndeterminateSolidIcon,
  "check-circle-off": CheckCircleOffIcon,
  "check-circle-on": CheckCircleOnIcon,
  checkmark: CheckmarkIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-up": ChevronUpIcon,
  circle: CircleIcon,
  clock: ClockIcon,
  close: CloseIcon,
  "cloud-download-outline": CloudDownloadOutlineIcon,
  collection: CollectionIcon,
  company: CompanyIcon,
  "connection-off": ConnectionOffIcon,
  contract: ContractIcon,
  "contract-vertical": ContractVerticalIcon,
  copy: CopyIcon,
  "credit-card": CreditCardIcon,
  crop: CropIcon,
  details: DetailsIcon,
  discounts: DiscountsIcon,
  doors: DoorsIcon,
  download: DownloadIcon,
  drag: DragIcon,
  edit: EditIcon,
  ellipses: EllipsesIcon,
  exclamation: ExclamationIcon,
  exit: ExitIcon,
  expand: ExpandIcon,
  "expand-vertical": ExpandVerticalIcon,
  "export-csv": ExportCsvIcon,
  file: FileIcon,
  filter: FilterIcon,
  flag: FlagIcon,
  flash: FlashIcon,
  "flash-solid": FlashSolidIcon,
  gift: GiftIcon,
  global: GlobalIcon,
  grid: GridIcon,
  group: GroupIcon,
  "heart-off": HeartOffIcon,
  "heart-on": HeartOnIcon,
  home: HomeIcon,
  hubs: HubsIcon,
  image: ImageIcon,
  kabob: KabobIcon,
  layer: LayerIcon,
  lightbulb: LightbulbIcon,
  link: LinkIcon,
  "link-out": LinkOutIcon,
  list: ListIcon,
  lock: LockIcon,
  menu: MenuIcon,
  merge: MergeIcon,
  message: MessageIcon,
  "mic-off": MicOffIcon,
  "mic-on": MicOnIcon,
  "minus-circle-outline": MinusCircleOutlineIcon,
  move: MoveIcon,
  no: NoIcon,
  "order-review": OrderReviewIcon,
  order: OrderIcon,
  pages: PagesIcon,
  paste: PasteIcon,
  "payment-methods": PaymentMethodsIcon,
  pause: PauseIcon,
  "person-add": PersonAddIcon,
  person: PersonIcon,
  phone: PhoneIcon,
  plane: PlaneIcon,
  play: PlayIcon,
  "price-types": PriceTypesIcon,
  qr: QrIcon,
  question: QuestionIcon,
  "radio-off": RadioOffIcon,
  "radio-on": RadioOnIcon,
  reset: ResetIcon,
  reply: ReplyIcon,
  search: SearchIcon,
  "send-backwards": SendBackwardsIcon,
  settings: SettingsIcon,
  "shipping-and-billing": ShippingAndBillingIcon,
  "shipping-methods": ShippingMethodsIcon,
  share: ShareIcon,
  "shopping-bag": ShoppingBagIcon,
  sort: SortIcon,
  "sound-off": SoundOffIcon,
  "sound-on": SoundOnIcon,
  "star-off": StarOffIcon,
  "star-on": StarOnIcon,
  subtract: SubtractIcon,
  sync: SyncIcon,
  tag: TagIcon,
  text: TextIcon,
  trash: TrashIcon,
  upload: UploadIcon,
  "video-off": VideoOffIcon,
  "video-on": VideoOnIcon,
  "visibility-off": VisibilityOffIcon,
  "visibility-on": VisibilityOnIcon,
  "visible-to-all": VisibleToAllIcon,
  warehouses: WarehousesIcon,
  warning: WarningIcon,
  "x-close": XCloseIcon,
} as const;

export const templateIconsMap = {
  "2-styles": _2Styles,
  "4-styles": _4Styles,
  "4-styles-A": _4StylesA,
  "4-styles-B": _4StylesB,
  "8-styles": _8Styles,
  "12-styles": _12Styles,
  "with-inventory-ats": WithInventoryATS,
  "by-fabrication": ByFabrication,
} as const;

export const fullIconMap = {
  ...semanticIconMap,
  ...nonSemanticIconMap,
  ...templateIconsMap,
};

export const semanticIconNames = Object.keys(semanticIconMap);
export const nonSemanticIconNames = Object.keys(nonSemanticIconMap);
export const templateIconsNames = Object.keys(templateIconsMap).sort();
export const allIconNames = Object.keys(fullIconMap).sort();

export type SemanticIcons = keyof typeof semanticIconMap;
export type NonSemanticIcons = keyof typeof nonSemanticIconMap;
export type TemplateIcons = keyof typeof templateIconsMap;
